import * as api from 'services/api'
import {  Toast } from 'mint-ui';
const normal = {
	state: {
		//id: '',
		detail: {},
		comments: [],
		hasComments: false,
		params:{
			sysCode:'',
			categoryId:'',
			id:'',
			isTimeLimit:false,
		}
		
	},
	mutations: {
		'normal:clear'(state) {
			state.params.sysCode='';
			state.params.categoryId='';
			state.params.id = '';
			state.params.isTimeLimit = false,
			state.detail = {};
			state.comments = [];
			state.hasComments = false;
		},
		'normal:update:params'(state,params) {
			state.params.sysCode=params.sysCode;
			state.params.categoryId=params.categoryId;
			state.params.id = params.id;
			state.params.isTimeLimit = params.isTimeLimit
		},
		'normal:update:detail'(state, detail) {
			state.detail = detail;
		},
		'normal:update:comments'(state, comments = []) {
			if(comments.length > 0) {
				state.hasComments = true;
			}
			state.comments.push(...comments);
		}
	},
	actions: {
		async 'normal:init'({commit, dispatch}, params) {
			//commit('normal:clear');
			commit('normal:update:params',params);
			// 获取详情数据
			dispatch('normal:update:detail');
			// 获取评论数据
			dispatch('normal:update:comments');
		},
		async 'normal:update:detail'({commit, state}) {
			if(state.params.sysCode === 'gov'){
				const res = await api.getDetailGov({articleId:state.params.id,categoryId:state.params.categoryId,sysCode:state.params.sysCode});
				if(res.code === 0) {
					let data = res.data;
					let medias_o = data.mediaList || [];
					data.medias = medias_o.map((item,index)=>{
						return {
							index:index,
							image:item.image,
							description:item.description
						}
					});
					commit('normal:update:detail', data);
				}
			}else{

				const res = state.params.isTimeLimit ? 
										await api.getDetailPreview({articleId:state.params.id,categoryId:state.params.categoryId,sysCode:state.params.sysCode}) : 
										await api.getDetail({articleId:state.params.id,categoryId:state.params.categoryId,sysCode:state.params.sysCode});
				if(res.code === 0) {
					let data = res.item;
					// let medias_o = data.medias || [];
					// let medias_n = [];
					// let orders = [];
					// for(let i = 0; i < medias_o.length; i++) {
					// 	if(orders.indexOf(medias_o[i].order) === -1) {
					// 		orders.push(medias_o[i].order);
					// 		medias_n.push(medias_o[i]);
					// 	}
					// }
					// data.medias = medias_n;
					commit('normal:update:detail', data);
				} else {
					Toast(res.msg)
				}
			}
		},
		async 'normal:update:comments'({commit, state}) {
			//0_topic_41
			// const res = await api.getHotComments({articleId: state.params.id,sysCode:state.params.sysCode});
			// if(res.result.code === 0) {
			// 	let data = res.data;
			// 	commit('normal:update:comments', data);
			// }
		}
	},
	getters: {
		'normal:detail': state => {
			return state.detail;
		},
		'normal:comments': state => {
			return state.comments;
		},
		'normal:hasComments': state => {
			return state.hasComments;
		}
	}
};

export default normal;


// WEBPACK FOOTER //
// ./src/store/modules/normal.js